import { getDocumentConciliationRateHistory } from 'lib/api/reports';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { DocumentConciliationRateHistory } from './types';

interface UseRateHistoryProps {
  open: boolean;
  documentId?: string;
  propRateHistory?: DocumentConciliationRateHistory | null;
  onHistoryLoaded?: (history: DocumentConciliationRateHistory) => void;
}

export const useRateHistory = ({
  open,
  documentId,
  propRateHistory,
  onHistoryLoaded,
}: UseRateHistoryProps) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [history, setHistory] =
    useState<DocumentConciliationRateHistory | null>(propRateHistory || null);
  const [error, setError] = useState<string | null>(null);

  const loadHistory = useCallback(async () => {
    if (!documentId) return;

    setLoading(true);
    setError(null);
    try {
      const data = await getDocumentConciliationRateHistory(
        dispatch,
        documentId,
      );
      if (data) {
        setHistory(data);
        if (onHistoryLoaded) {
          onHistoryLoaded(data);
        }
      } else {
        setError('No se pudo cargar el historial');
      }
    } catch (err) {
      console.error('Error loading rate history:', err);
      setError('Error al cargar el historial de tasas');
    } finally {
      setLoading(false);
    }
  }, [documentId, dispatch, onHistoryLoaded]);

  useEffect(() => {
    if (open && documentId) {
      if (propRateHistory) {
        setHistory(propRateHistory);
      } else {
        void loadHistory();
      }
    } else {
      setHistory(propRateHistory || null);
      setError(null);
    }
  }, [open, documentId, propRateHistory, loadHistory]);

  return { loading, error, history };
};
